import * as React from "react";
const NotifyIcon = (props: any) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27 22.1875C27 16 21.508 17.375 21.508 12.5625C21.508 12.1638 21.4697 11.823 21.3998 11.5328C21.0387 9.10468 19.4227 7.156 17.3286 6.56217C17.3472 6.47735 17.3569 6.38961 17.3569 6.29985C17.3569 5.58489 16.7391 5 15.9839 5C15.2288 5 14.6109 5.58489 14.6109 6.2998C14.6109 6.38961 14.6207 6.47735 14.6392 6.56213C12.2908 7.2281 10.5436 9.59783 10.4934 12.4369C10.4925 12.4781 10.492 12.5199 10.492 12.5625C10.492 17.375 5 16 5 22.1875C5 23.8252 8.65966 25.1952 13.5591 25.5408C14.0208 26.4088 14.9333 27 15.9839 27C17.0345 27 17.947 26.4088 18.4087 25.5408C23.3082 25.1952 26.9678 23.8252 26.9678 22.1875C26.9678 22.1826 26.9673 22.1777 26.9672 22.1728L27 22.1875ZM22.7254 23.3497C21.562 23.6606 20.1906 23.8842 18.7187 24.0082C18.5963 22.6027 17.419 21.5 15.9839 21.5C14.5488 21.5 13.3715 22.6027 13.2491 24.0082C11.7773 23.8842 10.4058 23.6606 9.24241 23.3497C7.64137 22.9219 6.87593 22.4433 6.5958 22.1875C6.87593 21.9317 7.64137 21.4531 9.24241 21.0253C11.1039 20.5279 13.4981 20.2539 15.9839 20.2539C18.4697 20.2539 20.8639 20.5279 22.7254 21.0253C24.3264 21.4531 25.0919 21.9317 25.372 22.1875C25.0919 22.4433 24.3264 22.9219 22.7254 23.3497Z"
      fill={props.style.fill ? props.style.fill : "#C7C7C7"}
    />
  </svg>
);
export default NotifyIcon;
